module.exports = __webpack_public_path__ + "img/inbox.e1f6f44c.svg";